//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { EventBus } from '../../EventBus/EventBus.js'
import { axiosGet, axiosPost } from '../../axios/axios.js'
import UpdatesManager from '../../components/UpdatesManager.js'

import { brigadeEditor } from '../../pages/main/sections/Brigades/Operations/BrigadeEditor.js'
import BrigadeMapBrigadeInformation from './BrigadeMapBrigadeInformation.vue'
import BrigadeAutoAssign from '../../pages/main/sections/Brigades/Operations/BrigadeAutoAssign.vue'
import BrigadeMapCurrentTasks from './BrigadeMapCurrentTasks.vue'
import BrigadeMapPerformedTasks from './BrigadeMapPerformedTasks.vue'
import BrigadeMapClosestTasks from './BrigadeMapClosestTasks.vue'
import BrigadeGeoTrackerMarker from './BrigadeGeoTrackerMarker.vue'
import EngineerBreakTime from '../../pages/engineer/EngineerBreakTime.vue'

export default {
  components: {
    BrigadeMapBrigadeInformation,
    BrigadeAutoAssign,
    BrigadeMapCurrentTasks,
    BrigadeMapClosestTasks,
    BrigadeMapPerformedTasks,
    BrigadeGeoTrackerMarker,
    EngineerBreakTime
  },
  mixins: [brigadeEditor],
  props: {
    brigadeId: {
      type: Number,
      default: null
    },
    mobile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loading: false,
      brigade: null,
      brigadeInitial: null,
      selectedTab: 'brigadeInformation',
      hasReportsOnRework: false,
      currentTasksNumber: 0,
      performedTasksNumber: 0,
      closestRequestsNumber: 0,
      state: 'Нет данных',
      regions: [],
      skipUpdatesWhileEditing: false,
      updatesManager: new UpdatesManager({
        autoUpdate: true,
        updateFn: () => {
          return this.loadBrigade()
        },
        skipUpdateFn: () => {
          return this.skipUpdates
        },
        componentName: 'BrigadePopup',
        listenDocumentVisibility: true
      })
    }
  },
  computed: {
    skipUpdates: function () {
      return this.selectedTab === 'autoAssign' || this.skipUpdatesWhileEditing
    },
    notMobile: function () {
      return !this.mobile
    }
  },
  watch: {
    brigadeId: function () {
      this.onUpdate()
    }
  },
  created: function () {
    this.onUpdate()

    EventBus.$on('update-requestsQueue', this.onUpdate)
  },
  activated: function () {
    this.onUpdate()

    this.updatesManager.restoreUpdates('componentActivity', true)
  },
  deactivated: function () {
    this.updatesManager.stopUpdates('componentActivity')
  },
  beforeDestroy: function () {
    this.updatesManager.destroy()
    EventBus.$off('update-requestsQueue', this.onUpdate)
  },
  methods: {
    onUpdate: function () {
      this.updatesManager.onUpdate()
    },
    onUpdateBreak: function () {
      this.onUpdate()
      EventBus.$emit('update-requestsQueue')
    },
    loadBrigade: function () {
      if (this.brigadeId) {
        this.loading = true
        this.$emit('start-loading')
        this.state = 'Нет данных'
        this.getRegions()

        const showFullListRequests = localStorage.getItem('dispatcherAssignmentsShowFullListRequests')

        const params = new URLSearchParams()
        params.append('id', this.brigadeId)
        params.append('currentWorkShift', true)
        if (showFullListRequests && showFullListRequests === 'true') {
          params.append('maxQueueRequestsCount', 30)
        }

        return axiosGet({
          url: '/service/delta/brigade/get?' + params.toString(),
          onSuccess: (response) => {
            const brigade = response.data

            this.hasReportsOnRework = false
            this.currentTasksNumber = 0

            if (brigade.completionRequests && brigade.completionRequests.length) {
              this.currentTasksNumber += brigade.completionRequests.length
              this.hasReportsOnRework = true
            }

            if (brigade.activeRequests && brigade.activeRequests.length) {
              this.currentTasksNumber += brigade.activeRequests.length
              const activeRequest = brigade.activeRequests[0]

              if (activeRequest.state == 'BS4') {
                if (activeRequest.objectAlias) {
                  this.state = 'Принята к исполнению заявка на ' + activeRequest.objectAlias
                } else if (activeRequest.requestExternalName) {
                  this.state = 'Принята к исполнению ' + activeRequest.requestExternalName
                } else {
                  this.state = 'Принята к исполнению заявка №' + activeRequest.key
                }
              } else if (activeRequest.state == 'BS5') {
                if (activeRequest.objectAlias) {
                  this.state = 'Выполняются работы по заявке на ' + activeRequest.objectAlias
                } else if (activeRequest.requestExternalName) {
                  this.state = 'Выполняются работы по ' + activeRequest.requestExternalName
                } else {
                  this.state = 'Выполняются работы по заявке №' + activeRequest.key
                }
              } else if (activeRequest.state == 'BS6') {
                if (activeRequest.objectAlias) {
                  this.state = 'Работы завершены по заявке на ' + activeRequest.objectAlias
                } else if (activeRequest.requestExternalName) {
                  this.state = 'Работы завершены по ' + activeRequest.requestExternalName
                } else {
                  this.state = 'Работы завершены по заявке №' + activeRequest.key
                }
              } else if (activeRequest.state == 'BS14') {
                if (activeRequest.objectAlias) {
                  this.state = 'Доработка объекта по заявке на ' + activeRequest.objectAlias
                } else if (activeRequest.requestExternalName) {
                  this.state = 'Доработка объекта по ' + activeRequest.requestExternalName
                } else {
                  this.state = 'Доработка объекта по заявке №' + activeRequest.key
                }
              } else if (activeRequest.state == 'BS15') {
                if (activeRequest.objectAlias) {
                  this.state = 'Доработка отчёта по заявке на ' + activeRequest.objectAlias
                } else if (activeRequest.requestExternalName) {
                  this.state = 'Доработка отчёта по ' + activeRequest.requestExternalName
                } else {
                  this.state = 'Доработка отчёта по заявке №' + activeRequest.key
                }
              }
            } else if (brigade.reinforcementRequests && brigade.reinforcementRequests.length) {
              for (let i = 0; i < brigade.reinforcementRequests.length; i++) {
                const request = brigade.reinforcementRequests[i]

                if (request.riStateId === 'RI2') {
                  if (request.objectAlias) {
                    this.state = 'Принята к исполнению заявка на усиление на ' + request.objectAlias
                  } else if (request.requestExternalName) {
                    this.state = 'Принята к исполнению на усиление ' + request.requestExternalName
                  } else {
                    this.state = 'Принята к исполнению заявка на усиление №' + request.key
                  }
                  break
                } else if (request.riStateId === 'RI3') {
                  if (request.objectAlias) {
                    this.state = 'Выполняются работы по заявке на усиление на ' + request.objectAlias
                  } else if (request.requestExternalName) {
                    this.state = 'Выполняются работы на усиление по ' + request.requestExternalName
                  } else {
                    this.state = 'Выполняются работы на усиление по заявке №' + request.key
                  }
                  break
                } else if (request.riStateId === 'RI4') {
                  if (request.objectAlias) {
                    this.state = 'Завершены работы на усиление по заявке на ' + request.objectAlias
                  } else if (request.requestExternalName) {
                    this.state = 'Завершены работы на усиление по ' + request.requestExternalName
                  } else {
                    this.state = 'Завершены работы на усиление по заявке №' + request.key
                  }
                  break
                }
              }

              if (this.state === 'Нет данных') {
                this.state = 'Нет активной заявки'
              }
            } else {
              this.state = 'Нет активной заявки'
            }

            if (brigade.queueRequests && brigade.queueRequests.length) {
              this.currentTasksNumber += brigade.queueRequests.length
            }

            this.performedTasksNumber = (brigade.performedRequests && brigade.performedRequests.length) || 0

            if (brigade.reinforcementRequests && brigade.reinforcementRequests.length) {
              this.currentTasksNumber += brigade.reinforcementRequests.length
            }

            this.closestRequestsNumber = (brigade.closestRequests && brigade.closestRequests.length) || 0

            brigade.autoRequestAssign = !!response.data.autoRequestAssign
            brigade.autoRequestAssignAsUrgent = !!response.data.autoRequestAssignAsUrgent
            brigade.autoAssignAllObjectRequests = !!response.data.autoAssignAllObjectRequests

            const brigadeCommonAutoAssignListProperties = this.brigadeCommonAutoAssignListProperties
            Object.defineProperty(brigade, 'hasCommonAutoAssignSettings', {
              get: function () {
                for (let i = 0; i < brigadeCommonAutoAssignListProperties.length; i++) {
                  const array = this[brigadeCommonAutoAssignListProperties[i]]
                  if (array && array.length) {
                    return true
                  }
                }
                return false
              }
            })
            const brigadeUrgentAutoAssignListProperties = this.brigadeUrgentAutoAssignListProperties
            Object.defineProperty(brigade, 'hasUrgentAutoAssignSettings', {
              get: function () {
                for (let i = 0; i < brigadeUrgentAutoAssignListProperties.length; i++) {
                  const array = this[brigadeUrgentAutoAssignListProperties[i]]
                  if (array && array.length) {
                    return true
                  }
                }
                return false
              }
            })
            Object.defineProperty(brigade, 'hasAutoAssignSettings', {
              get: function () {
                return this.hasCommonAutoAssignSettings || this.hasUrgentAutoAssignSettings
              }
            })

            const employees = brigade.employees || []
            employees.forEach(employee => {
              employee.brigadier = employee.id === brigade.brigadier
              employee.driver = brigade.driverId.includes(employee.id)
            })
            employees.sort((a, b) => (a.brigadier === b.brigadier) ? 0 : a.brigadier ? -1 : 1)
            brigade.employees = employees

            this.brigade = brigade
            this.brigadeInitial = JSON.parse(JSON.stringify((brigade)))
          },
          onFailure: 'Ошибка загрузки информации о бригаде',
          msgTarget: this
        }).finally(
          () => {
            setTimeout(
              () => {
                this.loading = false
                this.$emit('end-loading')
              },
              500)
          }
        )
      }
      return Promise.resolve()
    },
    getRegions: function () {
      const urlParams = new URLSearchParams()
      urlParams.append('params', JSON.stringify([
        { param: 'showInFilter', type: 'boolean', action: '=', value: true },
        { param: 'shortName', type: 'string', action: 'any' }
      ]))
      axiosGet({
        url: '/service/obj/search?type=Region&limit=1000&' + urlParams.toString(),
        onSuccess: (response) => {
          this.regions = response.data.result
        },
        onFailure: 'Ошибка получения округов',
        msgTarget: this
      })
    },
    onSave: function () {
      this.saveBrigadeObject()
    },
    getBrigadeObjectToSave: function () {
      const formattedBrigade = {
        id: this.brigade.id,
        name: this.brigade.name,
        brigadier: this.brigadier,
        checkWorkAreas: true // TODO: Fix.
      }

      this.pushBrigadeBooleanPropertiesToSave(formattedBrigade, this.brigade, this.brigadeInitial, this.brigadeBooleanProperties) // !!!
      this.pushBrigadeListPropertiesToSave(formattedBrigade, this.brigade, this.brigadeInitial, [
        'fixedEmployees',
        'workAreas',
        { from: 'regions', to: 'region' }
      ])
      this.pushBrigadeListPropertiesToSave(formattedBrigade, this.brigade, this.brigadeInitial, this.brigadeAutoAssignListProperties) // !!!
      return formattedBrigade
    },
    saveBrigadeObject: function () {
      const brigade = this.getBrigadeObjectToSave()

      const bodyFormData = new FormData()
      bodyFormData.set('data', JSON.stringify([brigade]))

      this.loading = true
      axiosPost({
        url: 'service/delta/brigade/change',
        data: bodyFormData,
        config: {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        },
        onFailure: 'Ошибка редактирования информации о бригаде',
        onSuccess: (response) => {
          if (response.data && response.data.errors && response.data.errors.length) {
            this.$q.notify({
              type: 'negative',
              message: response.data.errors.join(', '),
              progress: true,
              timeout: 8000
            })
          } else {
            this.$q.notify({
              type: 'positive',
              message: 'Изменена бригада "' + brigade.name + '"',
              progress: true,
              timeout: 3000
            })
          }
        },
        throws: true
      })
        .then(this.onChangeSuccess)
        .then(this.onUpdate)
        .catch(() => {})
        .finally(() => {
          setTimeout(() => {
            this.loading = false
          }, 500)
        })
    }
  }
}

